export default {
  state: {
    depotList: [],
    parkingList: [],
    marshallingList: []

  },
  getters: {
    depotList: state => state.depotList,
    parkingList: state => state.parkingList,
    marshallingList: state => state.marshallingList
  },
  mutations: {
    depotList (state, data) {
      state.depotList = data
    },
    parkingList (state, data) {
      state.parkingList = data
    },
    marshallingList (state, data) {
      state.marshallingList = data
    }
  },
  actions: {
    handleDepotList (depotList, data) {
      depotList.commit('depotList', data)
    },
    handleParkingList (parkingList, data) {
      parkingList.commit('parkingList', data)
    },
    handleMarshallingList (marshallingList, data) {
      marshallingList.commit('marshallingList', data)
    }
  }
}
